import React, { useEffect, useState } from "react";
import emptyList from "../../utils/emptyList.png";
import expand from "../../utils/expand.png";
import deleteIcon from "../../utils/delete.png";
import products from "../../utils/products.png";
import ViewLead from "../../modals/ViewLead";
import { Menu, MenuItem, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { AiFillDelete } from "react-icons/ai";
import { Sparkle } from "lucide-react";

const statusMapping = {
  newLead: "New Lead",
  contacted: "Contacted",
  attemptedToContact: "Attempted to Contact",
  // qualified: "Qualified",
  unQualified: "Unqualified",
};

const statusClasses = {
  newLead: "bg-orange-400",
  contacted: "bg-blue-600",
  attemptedToContact: "bg-red-400",
  qualified: "bg-green-400",
  unQualified: "bg-red-600",
};

// const KanbanViewLeads = ({ rows, setRows, onDeleteChecked, groupedRows ,onEditLead , handleInputChange}) => {
const KanbanViewLeads = ({
  rows,
  setRows,
  onDeleteChecked,
  onEditLead,
  handleInputChange,
  clickedOnEditLead,
}) => {
  const groupedRows = rows.reduce((acc, row) => {
    acc[row.lead_status] = acc[row.lead_status] || [];
    acc[row.lead_status].push(row);
    return acc;
  }, {});

  console.log("rows:", rows);

  useEffect(() => {
    console.log("groupedRows:", groupedRows);
    setRows(rows);
    console.log("Rows:", rows);
  }, [groupedRows]);

  // Handle drag and drop
  const onDragStart = (e, leadId, fromStatus) => {
    e.dataTransfer.setData("leadId", leadId);
    e.dataTransfer.setData("fromStatus", fromStatus);
  };

  const onDrop = (e, newStatus) => {
    const leadId = e.dataTransfer.getData("leadId");
    const fromStatus = e.dataTransfer.getData("fromStatus");

    if (fromStatus === newStatus) return; // Skip if the status is unchanged

    // Update the row's status
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === parseInt(leadId, 10) ? { ...row, status: newStatus } : row,
      ),
    );
  };

  const allowDrop = (e) => {
    e.preventDefault(); // Allow dropping
  };

  const calculateAgedDays = (leadEntryTime) => {
    const entryTime = new Date(leadEntryTime);
    const currentTime = new Date();
    const diffInMilliseconds = currentTime - entryTime;

    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(
      (diffInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );

    return `Aged Days: ${diffInDays} d, ${diffInHours} h`;
  };

  const [selectedLead, setSelectedLead] = useState(null); // Track selected lead for the modal
  const [viewLeadModal, setViewLeadModal] = useState(false);

  const handleViewLead = (lead) => {
    console.log("view opened");
    handleKebabMenuClose();
    setSelectedLead(lead);
    console.log("selectedlead 195 handle view:", lead);
    setViewLeadModal(true);
  };

  const handleDeleteLead = (lead) => {
    console.log("handleDeleteLead:", lead);
    handleKebabMenuClose();
    setSelectedLead(lead);
    // setViewLeadModal(true);
    onDeleteChecked();
  };

  // const deleteSelectedLeads = () => {
  //   console.log('inside deleteSelectedLeads')
  //   const updatedLeads = filteredLeadRows.filter(
  //     (lead) => !selectedLeads.includes(lead.id)
  //   );
  //   setFilteredLeadRows(updatedLeads);
  //   setRows((prevRows) =>
  //     prevRows.filter((lead) => !selectedLeads.includes(lead.id))
  //   );
  //   setSelectedLeads([]); // Clear selected leads after deletion
  //   setShowDeleteModal(false); // Close modal after deletion
  // };

  const closeViewLeadModal = () => {
    console.log("clode lead view modal");
    setViewLeadModal((prev) => !prev);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleKebabMenuClick = (event, lead) => {
    setAnchorEl(event.currentTarget);
    if (lead) setSelectedLead(lead);
  };

  const handleKebabMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="flex gap-4  mt-2 ">
      {Object.keys(statusMapping).map((status, index) => (
        <div
          key={`${status}-${index}`}
          className="flex-1 bg-gray-100 rounded shadow-md  "
          // role="button"
          // aria-dropeffect="move"
          onDragOver={allowDrop}
          onDrop={(e) => onDrop(e, status)}
        >
          <h2
            className={`text-lg font-normal text-center p-2 mb-2 text-white ${statusClasses[status]} rounded-t`}
          >
            {statusMapping[status]}
          </h2>
          <div className="flex flex-col gap-1 py-1 h-[90vh]  overflow-y-auto scrollbar-hide ">
            {groupedRows[status]?.map((lead, idx) => (
              <div
                key={`${lead.id}-${idx}`}
                className="bg-white rounded shadow p-3 mx-2 my-1 hover:bg-gray-50 cursor-grab active:cursor-grabbing transition-all"
                draggable
                onDragStart={(e) => onDragStart(e, lead.id, lead.lead_status)}
              >
                {/* Header Section: Name + Icons + Menu */}
                <div className="flex justify-between items-center mb-1">
                  <h3 className="font-semibold text-gray-800 truncate mr-2">
                    {lead.lead_primarycontact}
                  </h3>

                  <div className="flex items-center gap-1.5">
                    <div className="flex gap-1">
                      {lead.lead_source?.split(",").map((source, sIdx) => {
                        const name = source.trim().toLowerCase();
                        const isAI = name.includes("ai");
                        const isWhatsApp = name === "whatsapp";

                        if (isWhatsApp)
                          return (
                            <div
                              key={sIdx}
                              className="bg-green-100 p-1 rounded-full text-green-600"
                              title="WhatsApp"
                            >
                              <svg
                                className="w-3 h-3"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 0 5.414 0 12.05c0 2.123.553 4.197 1.603 6.02L0 24l6.135-1.61a11.802 11.802 0 005.91 1.586h.005c6.637 0 12.05-5.414 12.05-12.05a11.813 11.813 0 00-3.541-8.518z" />
                              </svg>
                            </div>
                          );
                        if (isAI)
                          return (
                            <div
                              key={sIdx}
                              className="bg-purple-100 p-1 rounded-full text-purple-600"
                              title="AI Lead"
                            >
                              <Sparkle className="w-3 h-3" />
                            </div>
                          );
                        return null;
                      })}
                    </div>

                    {lead.Cnt > 1 && (
                      <img
                        src={products}
                        alt="products"
                        className="w-4 h-4 bg-green-500 p-0.5 rounded"
                      />
                    )}

                    <IconButton
                      onClick={(e) => handleKebabMenuClick(e, lead)}
                      sx={{ padding: "0px" }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      sx={{
                        "& .MuiPaper-root": {
                          boxShadow: "0px 2px 2px 0px rgba(74, 74, 86, 0.2)",
                        },
                      }}
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleKebabMenuClose}
                    >
                      <MenuItem onClick={() => handleDeleteLead(selectedLead)}>
                        <div className="flex justify-between items-center gap-2">
                          <span>Delete</span>
                          <img
                            src={deleteIcon}
                            alt="delete-icon"
                            className="w-4 h-4 cursor-pointer"
                          />
                        </div>
                      </MenuItem>
                      <MenuItem onClick={() => handleViewLead(selectedLead)}>
                        <div className="flex justify-between items-center gap-2 ">
                          <span>View</span>
                          <img
                            src={expand}
                            alt="expand-icon"
                            className="w-4 h-4 cursor-pointer"
                          />
                        </div>
                      </MenuItem>
                    </Menu>
                  </div>
                </div>

                {/* Details Section */}
                <div className="space-y-0.5">
                  <p className="text-xs text-gray-500 truncate">
                    {lead.lead_organization || "No organization"}
                  </p>
                  <p
                    className="text-xs text-gray-500  max-w-sm line-clamp-3"
                    title={lead.lead_primarycontacttitle || "No title"}
                  >
                    {lead.lead_primarycontacttitle || "No title"}
                  </p>
                  <p className="text-xs text-blue-600 truncate">
                    {lead.lead_email || "No email"}
                  </p>
                </div>

                {/* Footer Section */}
                <p className="text-[10px] text-center font-medium bg-gray-200 px-2 py-0.5 mt-2 rounded text-gray-700">
                  {calculateAgedDays(lead.lead_entryTime)}
                </p>
              </div>
            ))}

            {!groupedRows[status]?.length && (
              <div className="flex flex-col justify-center items-center text-gray-500">
                <img src={emptyList} alt="emptylist" className="w-32 h-24" />
                <p className="text-gray-400 pb-2 text-center">No leads</p>
              </div>
            )}
          </div>
        </div>
      ))}

      {viewLeadModal && (
        <ViewLead
          selectedLead={selectedLead}
          onClose={closeViewLeadModal}
          onEditLead={onEditLead}
          clickedOnEditLead={clickedOnEditLead}
        />
      )}
    </div>
  );
};

export default KanbanViewLeads;
